import { CONFIRM_PLACE_ORDER, PRODUCT_SELECTION_STAGE, REVIEW_STAGE, SUBSCRIPTION_DETAILS_STAGE } from '_constants/GlobalConstants';
import React, { useState } from 'react';
import OrderConfirmation from './OrderConfirmation';
import Review from './Review';
import SelectDetails from './SelectDetails';
import SelectProduct from './SelectProduct';

const StoreOrderForm = (props) => {
    let { defaultSelectedCategory, progressStep, handleStepUpdate } = props;

    const [selectedCategory, setSelectedCategory] = useState(defaultSelectedCategory);

    /**VSTS Specific START*/
    const [selectedVSTSSubscriptionInfoId, setselectedVSTSSubscriptionInfoId] = useState(0);
    const [selectedVSTSProductInfoDetails,setVSTSSelectedProductInfoDetails] = useState(null);
    const [selectedVSTSStartDate, setSelectedVSTSStartDate] = useState(null);
    const [selectedVSTSEndDate, setSelectedVSTSEndDate] = useState(null);
    /**VSTS Specific END*/

    /**VSTT Specific START*/
    const [selectedVSTTProducts, setSelectedVSTTProducts] = useState([]); //This is called when environment is selected
    const [selectedVSTTProductInfoDetails, setVSTTSelectedProductInfoDetails] = useState([]); //Store the final subscription after subscription is selected
    const [selectedVSTTSubscriptions, setSelectedVSTTSubscriptions] = useState([]); //Use for placing order
    const [totalVSTTSetupFee,setTotalVSTTSetupFee] = useState(0);
    const [totalVSTTMonthlyFee,setTotalVSTTMonthlyFee] = useState(0);
    const [totalVSTTYearlyFee, setTotalVSTTYearlyFee] = useState(0);
    /**VSTT Specific END*/

    /**Fee Waiver or Fee Discount Specific START*/
    const [selectedFeeWaiverId, setSelectedFeeWaiverId] = useState(-1);
    const [feeWaiverOptions, setFeeWaiverOptions] = useState([]);
    /**Fee Waiver or Fee Discount Specific END*/

    const [orderConfirmation ,setOrderConfirmation] = useState(null);   

    switch (progressStep){
        case PRODUCT_SELECTION_STAGE:
            return (
                <SelectProduct selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory}
                    
                    selectedVSTSSubscriptionInfoId={selectedVSTSSubscriptionInfoId} setselectedVSTSSubscriptionInfoId={setselectedVSTSSubscriptionInfoId}
                    setSelectedVSTSStartDate={setSelectedVSTSStartDate}
                    setSelectedVSTSEndDate={setSelectedVSTSEndDate}
                    setVSTSSelectedProductInfoDetails={setVSTSSelectedProductInfoDetails}

                    selectedVSTTProducts={selectedVSTTProducts} setSelectedVSTTProducts={setSelectedVSTTProducts}

                    handleStepUpdate={handleStepUpdate}                    
                /> 
            );
        case SUBSCRIPTION_DETAILS_STAGE:
            return (
                <SelectDetails selectedCategory={selectedCategory}

                    selectedVSTSSubscriptionInfoId={selectedVSTSSubscriptionInfoId}
                    selectedVSTSStartDate={selectedVSTSStartDate} setSelectedVSTSStartDate={setSelectedVSTSStartDate}
                    selectedVSTSEndDate={selectedVSTSEndDate} setSelectedVSTSEndDate={setSelectedVSTSEndDate}

                    selectedVSTTProducts={selectedVSTTProducts} setSelectedVSTTProducts={setSelectedVSTTProducts}
                    selectedVSTTProductInfoDetails={selectedVSTTProductInfoDetails} setVSTTSelectedProductInfoDetails={setVSTTSelectedProductInfoDetails} // Contain informations of all the subscriptions in a product
                    setSelectedVSTTSubscriptions={setSelectedVSTTSubscriptions} // The specific subscription chosen for the product (setup + monthly/annually)
                    setTotalVSTTSetupFee={setTotalVSTTSetupFee}
                    setTotalVSTTMonthlyFee={setTotalVSTTMonthlyFee}
                    setTotalVSTTYearlyFee={setTotalVSTTYearlyFee}

                    selectedFeeWaiverId={selectedFeeWaiverId} setSelectedFeeWaiverId={setSelectedFeeWaiverId}
                    feeWaiverOptions={feeWaiverOptions} setFeeWaiverOptions={setFeeWaiverOptions}

                    handleStepUpdate={handleStepUpdate}
                />
            );
        case REVIEW_STAGE:
            return (
                <Review 
                    selectedCategory={selectedCategory}

                    selectedVSTSSubscriptionInfoId={selectedVSTSSubscriptionInfoId} selectedVSTSStartDate={selectedVSTSStartDate} selectedVSTSEndDate={selectedVSTSEndDate} 
                    selectedVSTSProductInfoDetails={selectedVSTSProductInfoDetails} setVSTSSelectedProductInfoDetails={setVSTSSelectedProductInfoDetails}

                    selectedVSTTProductInfoDetails={selectedVSTTSubscriptions} setVSTTSelectedProductInfoDetails={setSelectedVSTTSubscriptions}                    
                    totalVSTTSetupFee={totalVSTTSetupFee} setTotalVSTTSetupFee={setTotalVSTTSetupFee}
                    totalVSTTMonthlyFee={totalVSTTMonthlyFee} setTotalVSTTMonthlyFee={setTotalVSTTMonthlyFee}
                    totalVSTTYearlyFee={totalVSTTYearlyFee} setTotalVSTTYearlyFee={setTotalVSTTYearlyFee}

                    feeWaiverOptions={feeWaiverOptions} selectedFeeWaiverId={selectedFeeWaiverId}                    

                    setOrderConfirmation={setOrderConfirmation}

                    handleStepUpdate={handleStepUpdate}
                />
            )
        case CONFIRM_PLACE_ORDER:
            return (
                <OrderConfirmation orderConfirmation={orderConfirmation} />
            );
        default:
            return (
                <SelectProduct handleStepUpdate={handleStepUpdate} />
            );
    } 
}

export default StoreOrderForm